/* eslint-disable */
export default {
  save: 'Enregistrer',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
